module.exports = __webpack_public_path__ + "static/img/banner2.ae7b7e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topImg/banner2.jpg
// module id = WPQK
// module chunks = 9